/**
 * Mason Grid Module
 */

export const initMasonGrid = () => {
	// Optional enhancement hook for Mason Grid if animations or interactivity are needed
};

// Self-initialize on DOMContentLoaded or immediately if DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		initMasonGrid();
	});
} else {
	initMasonGrid();
}
